<script setup lang="ts">
import MissedCallsStores from './MissedCallsStores.vue'
const { t } = useI18n()

const isLoaded = ref(true)
const { selectedStore } = useStore()
const { stores } = useLocalStorage()

const selectedStoreId = ref(undefined)

const fetchData = () => {
  if (stores.value.length > 1) {
    selectedStoreId.value = selectedStore.value
  }
}
</script>

<template>
  <div v-if="isLoaded">
    <div>
      <TheDetailHeader
        :title="t('pages.missedCalls.missedCallsSettingsPage.title')"
        :parent="{ label: t('pages.missedCalls.missedCallsDetailPage.title'), to: { name: 'MissedCallsList' } }"
      >
        <template #actions>
          <ThePageSettings :display-store-selector="true" @store-selected="fetchData" />
        </template>
      </TheDetailHeader>
      <div class="px-6 pb-6 sm:px-12 sm:pb-12">
        <MissedCallsStores :selected-store-id="selectedStoreId" />
      </div>
    </div>
  </div>
  <TheLoadingPage v-else />
</template>
